<template>
  <div class="timeline-player">
    <!-- 时间轴 -->
    <div class="slider-demo-block">
      <span class="demonstration">
        <div class="imgBox">
          <img v-if="isPlaying" src="@/views/imgs/pause.png" alt="" @click.stop="$emit('pause')" />
          <img v-else src="@/views/imgs/play.png" alt="" @click="$emit('play')" />
        </div>
      </span>
      <el-slider
        :model-value="modelValue"
        :step="1"
        :max="max"
        :marks="marks"
        :key="max"
        class="sli"
        @change="$emit('change', $event)"
        @input="handleInput($event)"
        :format-tooltip="formatTooltip"
        :tooltip-class="'custom-tooltip'"
      />
    </div>

    <!-- 时间显示 -->
    <div class="block2">{{ currentTimeText }}</div>
    <div class="block21">{{ startTimeText }}</div>
    <div class="block22">{{ endTimeText }}</div>
  </div>
</template>

<script setup>
defineProps({
  modelValue: { type: Number, default: 0 },
  max: { type: Number, default: 0 },
  marks: { type: Object, default: () => ({}) },
  isPlaying: { type: Boolean, default: false },
  currentTimeText: { type: String, default: '' },
  startTimeText: { type: String, default: '' },
  endTimeText: { type: String, default: '' },
  formatTooltip: { type: Function, default: () => '' }
});

const emit = defineEmits(['update:modelValue', 'play', 'pause', 'change', 'input']);

const handleInput = (val) => {
  emit('update:modelValue', val);
  emit('input', val);
};
</script>

<style lang="less" scoped>
:deep(.el-slider__runway) {
  background-color: #819391;
}
.slider-demo-block {
  width: 100%;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 80px;
  z-index: 1207;

  .el-slider {
    margin-top: 0;
    margin-left: 12px;
  }

  .demonstration {
    font-size: 14px;
    color: var(--el-text-color-secondary);
    line-height: 44px;
    flex: 0.3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 0;
  }

  .demonstration + .el-slider {
    flex: 0 0 70%;
  }
}

.imgBox {
  margin: 0 auto;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #fff;
  padding: 10px;
  box-sizing: border-box;

  img {
    width: 30px;
    height: 30px;
  }
}

.block2 {
  position: fixed;
  margin: 0;
  top: 80px;
  left: 36%;
  z-index: 999;
  padding: 5px 15px;
  border-radius: 20px;
  text-align: center;
  color: #4ed7ff;
  background-color: #0b0f3960;
  font-size: 24px;

  &:hover { background-color: #0b0f39; }
}

.block21 {
  position: fixed;
  bottom: 40px;
  left: 6%;
  z-index: 999;
  padding: 5px 15px;
  border-radius: 20px;
  text-align: center;
  color: #fff;
  background-color: #0b0f3960;

  &:hover { background-color: #0b0f39; }
}

.block22 {
  position: fixed;
  bottom: 40px;
  right: 17%;
  z-index: 999;
  padding: 5px 15px;
  border-radius: 20px;
  text-align: center;
  color: #fff;
  background-color: #0b0f3960;

  &:hover { background-color: #0b0f39; }
}

@media screen and (max-width: 768px) {
  .block2 {
    top: 44px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 14px;
    padding: 4px 10px;
    white-space: nowrap;
  }

  .block21 {
    bottom: 120px;
    left: 8px;
    font-size: 11px;
    padding: 3px 8px;
  }

  .block22 {
    bottom: 120px;
    right: 8px;
    font-size: 11px;
    padding: 3px 8px;
  }

  .slider-demo-block {
    width: 100%;
    bottom: 60px;
    padding: 0 10px;
    box-sizing: border-box;

    .demonstration {
      flex: 0 0 50px;
      margin-right: 4px;
    }

    .demonstration + .el-slider {
      flex: 1 1 auto;
    }
  }

  .imgBox {
    width: 36px;
    height: 36px;
    padding: 6px;

    img {
      width: 24px;
      height: 24px;
    }
  }
}

@media screen and (max-width: 576px) {
  .block21, .block22 { display: none; }
  .block2 { font-size: 12px; padding: 3px 8px; }
}

@media screen and (max-width: 400px) {
  .block2 { font-size: 10px; padding: 2px 6px; top: 38px; }
}
</style>
